import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { FC, useEffect, useRef, useState } from "react";
import {
  appointmentResearchNew,
  AppointmentsToExtract,
  CommonFieldsData,
  ctrlAgeRias,
  doctor,
  extractAppointments,
  locations,
  riassAppuntamenti,
  selAgeWeb,
  typology,
} from "../networking";
import { Controller, useForm } from "react-hook-form";
import "../css/bookingCalendar.css";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/premium-common";
import itLocale from "@fullcalendar/core/locales/it";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import listPlugin from "@fullcalendar/list";
import {
  AppointmentData,
  Doctor,
  Location,
  Typology,
} from "../services/interfaces";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import ModalAppointmentByAgenda from "./ModalAppointmentByAgenda";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import isoWeek from "dayjs/plugin/isoWeek";
import debounce from "lodash/debounce";
import "dayjs/locale/it";
import { Helmet } from "react-helmet-async";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { DataGrid, GridColDef, itIT } from "@mui/x-data-grid";
import { AllertMessage } from "./DoctorsList/Medint/MedintDetails/MedintDetails";
import warningIcon from "../assets/icons/WarningIcon.svg";
import { IconButton } from "@mui/material";
import { set } from "lodash";

dayjs.extend(isoWeek);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.locale("it");

type SelAgeWebPayload = {
  codMedint?: string;
  idMedpgm?: string;
  codPgmedt?: string;
  idPgmedt?: string;
  codTpgpre?: string;
  codSpecia?: string;
  codAnapre?: string;
  dataRif?: string;
};

type CtrlAgeRiasInfo = {
  idAgenda?: string;
  codiceAgenda?: string;
  agendaGP?: string;
  segnalaAgenda: boolean;
};

type AppuntamentiDaSpostareProps = {
  rows: AppointmentsToExtract[];
  onSelectionChange: (selected: AppointmentsToExtract[]) => void;
  onOpenRicercaAgenda: (row: AppointmentsToExtract) => void;
  alertById?: Record<string, boolean>;
  selectedIds: string[];
  onSelectedIdsChange: (ids: string[]) => void;
};

// Tipi per le righe agenda
type AgendaRow = {
  id: string;
  codPgmedt: string;
  desPgmedt: string;
  idPgmedt: string;
  codMedint: string;
  codTpgpre: string;
  idMedpgm: string;
  codAgendaGP: string;
  dataIni: string;
  dataFin: string;
};

type RicercaAgendaModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: (selected: AgendaRow | null) => void;
  initialFilters?: {
    medicoSostituto?: string;
    prestazione?: string;
    tipologia?: string;
  };
  selectedRow: AppointmentsToExtract | null;
};

const AppuntamentiDaSpostare = ({
  rows,
  onSelectionChange,
  onOpenRicercaAgenda,
  alertById = {},
  selectedIds,
  onSelectedIdsChange,
}: AppuntamentiDaSpostareProps) => {
  console.log("Appuntamenti ricevuti:", rows);

  const columns: GridColDef[] = [
    { field: "id", editable: false, flex: 1 },
    {
      field: "data",
      headerName: "Data",
      editable: false,
      flex: 1,
      valueFormatter: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YY") : "",
    },
    {
      field: "ora",
      headerName: "Ora",
      editable: false,
      flex: 1,
    },
    {
      field: "durata",
      headerName: "D",
      editable: false,
      flex: 0.5,
      renderHeader: (params) => (
        <Tooltip title="Durata" arrow>
          <span>{params.colDef.headerName}</span>
        </Tooltip>
      ),
    },
    {
      field: "tipologia",
      headerName: "T",
      editable: false,
      flex: 1,
    },
    {
      field: "paziente",
      headerName: "Paziente",
      editable: false,
      flex: 1,
    },
    {
      field: "telefono",
      headerName: "Telefono",
      editable: false,
      flex: 1,
    },
    {
      field: "esame",
      headerName: "Esame",
      editable: false,
      flex: 1,
    },
    {
      field: "note",
      headerName: "Note",
      editable: false,
      flex: 1,
      renderCell: (params) => {
        const row = params.row as AppointmentsToExtract;
        const mustWarn = !!(alertById && alertById[row.id]);

        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
              overflow: "hidden",
            }}
          >
            {mustWarn && (
              <Tooltip title="Ricerca Agenda" arrow>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onOpenRicercaAgenda(row);
                  }}
                  sx={{ p: 0.5 }}
                >
                  <Box
                    component="img"
                    src={warningIcon}
                    alt="Apri Ricerca Agenda"
                    sx={{ width: 18, height: 18 }}
                  />
                </IconButton>
              </Tooltip>
            )}

            <Typography
              variant="body2"
              noWrap
              sx={{ flex: 1 }}
              title={params.value ?? ""}
            >
              {params.value ?? ""}
            </Typography>
          </Box>
        );
      },
    },
  ];

  const [appointmentToMove, setAppointmentToMove] = useState<any[]>([]);

  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", width: "100%" }}
      borderRadius={2}
    >
      {rows.length === 0 ? (
        <Typography> </Typography>
      ) : (
        <DataGrid
          selectionModel={selectedIds}
          onSelectionModelChange={(model) => {
            const ids = model as string[];
            onSelectedIdsChange(ids);
            const selectedRows = rows.filter((r) => ids.includes(r.id));
            onSelectionChange(selectedRows);
          }}
          getRowId={(row) => row.id}
          sx={{
            border: "1px solid #ccc",
            width: "100%",
            borderRadius: 2,
            display: "flex",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#003267",
              color: "#FFFFFF",
            },
            "& .MuiDataGrid-row:nth-of-type(even)": {
              backgroundColor: "#F8F9FC",
            },
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: "#FFFFFF",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
              color: "#FFFFFF",
              "&.Mui-checked": {
                color: "#FFFFFF",
              },
            },
            "& .MuiDataGrid-iconButtonContainer": {
              color: "#FFFFFF",
            },
            "& .MuiDataGrid-sortIcon": {
              color: "#FFFFFF",
            },
            "& .MuiDataGrid-columnSeparator": {
              display: "none",
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
              {
                outline: "none",
              },
            "& .cell-duration:hover": {
              cursor: "pointer",
              backgroundColor: "#DFEAFF",
              border: "1px solid #003267",
            },
          }}
          rows={rows}
          columns={columns}
          headerHeight={36}
          rowHeight={36}
          initialState={{
            columns: {
              columnVisibilityModel: {
                id: false,
              },
            },
          }}
          hideFooter
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          checkboxSelection
          disableColumnFilter
          disableColumnMenu
          getCellClassName={(params) => {
            return params.field === "durata" ? "cell-duration" : "";
          }}
          // onSelectionModelChange={(newSelection) => {
          //   setSelectionModel(newSelection as number[]);
          // }}
        />
      )}
    </Box>
  );
};

const RicercaAgendaModal: FC<RicercaAgendaModalProps> = ({
  open,
  onClose,
  onConfirm,
  initialFilters,
  selectedRow,
}) => {
  type Filters = {
    medicoSostituto: string;
    prestazione: string;
    tipologia: string;
  };

  const [filters, setFilters] = useState<Filters>({
    medicoSostituto: initialFilters?.medicoSostituto ?? "",
    prestazione: initialFilters?.prestazione ?? "",
    tipologia: initialFilters?.tipologia ?? "",
  });

  const [rows, setRows] = useState<AgendaRow[]>([]);
  const [selectionModel, setSelectionModel] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [selAgeWebRaw, setSelAgeWebRaw] = useState<any>(null);
  const [tipOptions, setTipOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [loadingOpts, setLoadingOpts] = useState(false);

  const formatDate = (value: any) => {
    if (!value) return "";
    const date = dayjs(value);
    return date.isValid() ? date.format("DD/MM/YYYY") : "";
  };

  const columns: GridColDef[] = [
    {
      field: "codAgenda",
      headerName: "Codice Agenda",
      flex: 1,
      minWidth: 140,
    },
    {
      field: "desPgmedt",
      headerName: "Descrizione",
      flex: 1.2,
      minWidth: 160,
    },
    { field: "codTpgpre", headerName: "Tipologia", flex: 1, minWidth: 140 },
    {
      field: "dataIni",
      headerName: "Data Inizio Validità",
      flex: 1,
      minWidth: 180,
      valueFormatter: (params) => formatDate(params.value),
    },
    {
      field: "dataFin",
      headerName: "Data Fine Validità",
      flex: 1,
      minWidth: 180,
      valueFormatter: (params) => formatDate(params.value),
    },
    {
      field: "codAgendaGP",
      headerName: "Codice Agenda GP",
      flex: 1,
      minWidth: 160,
    },
  ];

  // Mantieni i campi bloccati allineati a eventuali cambi di initialFilters
  useEffect(() => {
    setFilters((f) => ({
      medicoSostituto: initialFilters?.medicoSostituto ?? f.medicoSostituto,
      prestazione: initialFilters?.prestazione ?? f.prestazione,
      tipologia: initialFilters?.tipologia ?? f.tipologia,
    }));
  }, [
    initialFilters?.medicoSostituto,
    initialFilters?.prestazione,
    initialFilters?.tipologia,
  ]);

  useEffect(() => {
    if (!open || !selectedRow) return;

    const body: CommonFieldsData = {
      listino: "",
      tipoAgenda: "",
      specialita: selectedRow.specialitaCod ?? "",
      prestazione: selectedRow.prestazioneCod ?? "",
      medico: [],
    };

    const ctrl = new AbortController();
    setLoadingOpts(true);

    typology(body, ctrl.signal)
      .then((res: any) => {
        const raw = (res?.data?.dati ?? []) as Typology[];
        const mapped = raw
          .map((t) => ({
            value: String(t.CODICE ?? ""),
            label: String(t.DESCRIZIONE ?? ""),
          }))
          .filter((o) => o.value);

        // dedup per codice
        const dedup = Array.from(
          new Map(mapped.map((o) => [o.value, o])).values()
        );
        setTipOptions(dedup);

        // se ho un valore iniziale e c'è nelle opzioni, lo tengo; altrimenti svuoto
        const initialCode = initialFilters?.tipologia ?? "";
        setFilters((f) => ({
          ...f,
          tipologia:
            initialCode && dedup.some((o) => o.value === initialCode)
              ? initialCode
              : "",
        }));
      })
      .catch((e) => console.error("typology error:", e))
      .finally(() => setLoadingOpts(false));

    return () => ctrl.abort();
  }, [open, selectedRow?.specialitaCod, selectedRow?.prestazioneCod]);

  const mapSelAgeWebToAgendaRows = (res: any): AgendaRow[] => {
    const blocchi = res?.data?.agende ?? res?.agende ?? [];
    const rows: AgendaRow[] = [];

    for (const b of blocchi) {
      const agendaArr = b?.agenda ?? [];
      for (const a of agendaArr) {
        rows.push({
          id: String(
            a?.idPgmedt ??
              a?.codPgmedt ??
              crypto.randomUUID?.() ??
              Math.random()
          ),
          codPgmedt: String(a?.codPgmedt ?? ""),
          desPgmedt: String(a?.desPgmedt ?? ""),
          idPgmedt: String(a?.idPgmedt ?? ""),
          codMedint: String(a?.codMedint ?? ""),
          codTpgpre: String(a?.codTpgpre ?? ""),
          idMedpgm: String(a?.idMedpgm ?? ""),
          codAgendaGP: String(a?.codAgendaGP ?? ""),
          dataIni: String(a?.dataInizioValidita ?? a?.dataIni ?? ""),
          dataFin: String(a?.dataFineValidita ?? a?.dataFin ?? ""),
        });
      }
    }

    // dedup su idPgmedt
    const dedup = Array.from(
      new Map(rows.map((r) => [r.idPgmedt || r.id, r])).values()
    );
    return dedup;
  };

  const buildPayload = (): SelAgeWebPayload => ({
    codMedint: String(filters.medicoSostituto ?? ""),
    codTpgpre: String(filters.tipologia ?? ""),
    codSpecia: String(selectedRow?.specialitaCod ?? ""),
    codAnapre: String(selectedRow?.prestazioneCod ?? ""),
    dataRif: String(selectedRow?.data ?? ""),
  });

  const handleSearch = async () => {
    if (!selectedRow || !filters.tipologia) return;
    setLoading(true);
    try {
      const res = await selAgeWeb(buildPayload());
      setRows(mapSelAgeWebToAgendaRows(res));
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = () => {
    const sel = rows.find((r) => r.id === selectionModel[0]) ?? null;
    if (!sel) {
      onConfirm(null);
      return;
    }

    const payload: AgendaRow = {
      ...sel,
      codTpgpre: String(filters.tipologia ?? ""),
    };

    onConfirm(payload);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 2,
          outline: "none",
          p: { xs: 2, md: 3 },
          width: { xs: "96vw", sm: "92vw", md: "86vw", lg: "80vw" },
          maxWidth: 1200,
          height: { xs: "92vh", md: "84vh" },
          display: "flex",
          flexDirection: "column",
          boxShadow: 24,
        }}
      >
        <Typography
          sx={{ fontWeight: "bold", mb: 2, fontSize: { xs: 18, md: 20 } }}
        >
          Ricerca Agenda
        </Typography>

        {/* Filtri */}
        <Box sx={{ mb: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                label="Medico Sostituto"
                fullWidth
                size="small"
                value={filters.medicoSostituto}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                label="Prestazione"
                fullWidth
                size="small"
                value={filters.prestazione}
                disabled
              />
            </Grid>

            <Grid item xs={12}>
              <FormControl fullWidth size="small">
                <InputLabel id="tipologia-label">Tipologia</InputLabel>
                <Select
                  labelId="tipologia-label"
                  label="Tipologia"
                  value={filters.tipologia ?? ""}
                  onChange={(e) =>
                    setFilters((f) => ({
                      ...f,
                      tipologia: String(e.target.value || ""),
                    }))
                  }
                  renderValue={(code) => {
                    const item = tipOptions.find((o) => o.value === code);
                    return item ? item.label : "";
                  }}
                  disabled={loadingOpts || tipOptions.length === 0}
                  displayEmpty
                >
                  {tipOptions.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  disabled={loading || !filters.tipologia}
                >
                  {loading ? "Ricerca..." : "Ricerca Agende"}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Tabella */}
        <Box sx={{ flex: 1, minHeight: 300 }}>
          {rows.length > 0 && (
            <DataGrid
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              checkboxSelection
              onSelectionModelChange={(m) => {
                setSelectionModel(m as string[]);
              }}
              selectionModel={selectionModel}
              headerHeight={40}
              rowHeight={38}
              disableColumnMenu
              hideFooter
              hideFooterPagination
              sx={{
                height: "100%",
                border: "1px solid #ccc",
                borderRadius: 2,
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#003267",
                  color: "#FFFFFF",
                },
                "& .MuiDataGrid-row:nth-of-type(even)": {
                  backgroundColor: "#F8F9FC",
                },
                "& .MuiDataGrid-row:nth-of-type(odd)": {
                  backgroundColor: "#FFFFFF",
                },
                "& .MuiDataGrid-columnHeaderTitle": { fontWeight: "bold" },
                "& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root": {
                  color: "#FFFFFF",
                  "&.Mui-checked": { color: "#FFFFFF" },
                },
                "& .MuiDataGrid-iconButtonContainer, & .MuiDataGrid-sortIcon": {
                  color: "#FFFFFF",
                },
                "& .MuiDataGrid-columnSeparator": { display: "none" },
                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                  { outline: "none" },
              }}
              localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
            />
          )}
        </Box>

        {/* Footer */}
        <Box
          sx={{
            mt: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button variant="outlinedError" onClick={onClose}>
            Uscita
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            disabled={selectionModel.length === 0}
          >
            Conferma
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

const RicercaPrenotazioni = ({
  setAppuntamenti,
  setSostituto,
  onCtrlAgeRiasReady,
  onSearchResult,
  onTypologyOptions,
}: {
  setAppuntamenti: React.Dispatch<React.SetStateAction<any[]>>;
  setSostituto: React.Dispatch<React.SetStateAction<string>>;
  onSearchResult?: (info: { searched: boolean; empty: boolean }) => void;
  onTypologyOptions?: (options: string[]) => void;
  onCtrlAgeRiasReady: (
    map: Record<
      string,
      {
        idAgenda?: string;
        codiceAgenda?: string;
        agendaGP?: string;
        segnalaAgenda: boolean;
      }
    >
  ) => void;
}) => {
  const [doctorList, setDoctorList] = useState<Doctor[]>([]);
  const [appointmentsToExtract, setAppointmentsToExtract] = useState<
    AppointmentsToExtract[]
  >([]);
  const [specialitiesList, setSpecialitiesList] = useState<string[]>([]);
  const [performanceList, setPerformanceList] = useState<string[]>([]);
  const [typologyList, setTypologyList] = useState<string[]>([]);
  const [appointmentsID, setAppointmentsID] = useState<any[]>([]);

  const { control, getValues, setValue, watch, handleSubmit } =
    useForm<AppointmentsToExtract>({
      defaultValues: {
        medico: "",
        sostituto: "",
        appuntamentiDal: "",
        appuntamentiAl: "",
      },
    });

  useEffect(() => {
    const fetchDoctors = async () => {
      const doctorRequest: CommonFieldsData = {
        listino: "",
        tipoAgenda: "",
        specialita: "",
        prestazione: "",
        medico: [],
      };

      const response = await doctor(doctorRequest);

      console.log(response.data.dati);
      setDoctorList(response.data.dati);
    };
    fetchDoctors();
  }, []);

  const formatHour = (time: any) => {
    if (!time || typeof time !== "string") {
      return ""; // Restituisce un valore di fallback se il tempo è indefinito o non è un numero
    }

    // Converte il numero in una stringa con zeri iniziali (se necessario)
    const timeString = time.toString().padStart(4, "0");

    // Prende le prime due cifre come ore e le ultime due come minuti
    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    // Restituisce l'orario formattato come HH:mm
    return `${hours}:${minutes}`;
  };

  const mapAppointments = (datiDaApi: any[]): AppointmentsToExtract[] => {
    return datiDaApi.map((app, index) => ({
      id: app.IDPACADA,
      data: app.DATAVISITA,
      ora: formatHour(app.ORAVISITA),
      durata: app.DURATA + " min",
      tipologia: app.CODTIPOLOGIA || "",
      tipologiaDesc: app.TIPOLOGIA || "",
      paziente: [app.NOMEPAZIENTE, app.COGNOMEPAZIENTE]
        .filter(Boolean)
        .join(" "),
      telefono: app.NUMTEL || "",
      esame: app.DESCPRESTAZIONE || "",
      medico: app.NOMINMEDICO,
      nuovaData: app.NUOVA_DATA,
      nuovaOra: app.NUOVA_ORA,
      note: app.NOTEPREN,
      appuntamentiDal: app.APPUNTAMENTIDAL,
      appuntamentiAl: app.APPUNTAMENTIAL,
      sostituto: app.SOSTITUTO || "",
      specialitaCod: app.CODSPECIALITA ?? "",
      specialitaDesc: app.DESCSPECIALITA ?? "",
      prestazioneCod: app.CODPRESTAZIONE ?? "",
    }));
  };

  const parseCtrlAgeRias = (res: any): Record<string, CtrlAgeRiasInfo> => {
    const map: Record<string, CtrlAgeRiasInfo> = {};

    const blocchi = res?.data?.appuntamenti ?? res?.appuntamenti ?? [];
    // struttura: [{ appuntamento: [ { idAppuntamento, codiceAgenda, idAgenda, desAgenda, agendaGP, segnalaAgenda }, ... ] }]
    for (const blocco of blocchi) {
      const arr = blocco?.appuntamento ?? [];
      for (const it of arr) {
        const id = String(it?.idAppuntamento ?? "");
        if (!id) continue;
        map[id] = {
          idAgenda: it?.idAgenda || "",
          codiceAgenda: it?.codiceAgenda || "",
          agendaGP: it?.agendaGP || "",
          segnalaAgenda: String(it?.segnalaAgenda ?? "") === "1",
        };
      }
    }

    return map;
  };

  const fetchAppointments = async () => {
    const dataValues = getValues();
    console.log(dataValues);

    setSostituto(dataValues.sostituto || "");
    setAppuntamenti([]);
    try {
      const dataValues = getValues();
      const requestValues = {
        dataInizio: dataValues.appuntamentiDal,
        dataFine: dataValues.appuntamentiAl,
        codMedint: dataValues.medico,
      };

      const response = await extractAppointments(requestValues);
      const result = response.data.dati.appuntamenti ?? [];
      const mappedData = mapAppointments(result);

      console.log("Response from extractAppointments:", response.data.dati);

      setAppointmentsToExtract(response.data.dati);

      // const getAppointmentsID = response.data.dati.map(
      //   (item: any) => item.IDPACADA
      // );

      // setAppointmentsID(getAppointmentsID);

      const getSpecialitiesList = response.data.dati.appuntamenti.map(
        (item: any) => item.CODSPECIALITA
      );
      setSpecialitiesList(getSpecialitiesList);
      const getPerformanceList = response.data.dati.appuntamenti.map(
        (item: any) => item.CODPRESTAZIONE
      );
      setPerformanceList(getPerformanceList);
      const getTypologyList = response.data.dati.appuntamenti.map(
        (item: any) => item.TIPOLOGIA ?? ""
      );
      const raw = (response.data?.dati?.appuntamenti ?? []).map((x: any) => ({
        value: String(x.CODTIPOLOGIA ?? ""),
        label: String(x.TIPOLOGIA ?? ""),
      }));
      const uniq = Array.from(
        new Map(
          raw
            .filter((o: any) => o.value) // scarta vuoti
            .map((o: any) => [o.value, o]) // dedup per codice
        ).values()
      );

      setTypologyList(uniq.map((o: any) => o.value));
      onTypologyOptions?.(uniq as any); // passa oggetti al modale

      setAppuntamenti(mappedData);

      onSearchResult?.({ searched: true, empty: mappedData.length === 0 });

      // creo l'array di oggetti { idAppuntamento: ... } da passare a ctrlAgeRias

      const appointmentsID = Array.from(
        new Set(result.map((r: any) => String(r.IDPACADA)))
      ) // dedup opzionale
        .filter(Boolean)
        .map((id: unknown) => ({ idAppuntamento: String(id) }));

      console.log({ appointmentsID });

      if (mappedData.length > 0) {
        const appointmentsID = Array.from(
          new Set(result.map((r: any) => String(r.IDPACADA)))
        )
          .filter(Boolean)
          .map((id: unknown) => ({ idAppuntamento: String(id) }));

        const responsectrlAgeRias = await ctrlAgeRias({
          appuntamenti: appointmentsID,
          medicoSostituto: dataValues.sostituto,
        });
        console.log("Response from ctrlAgeRias:", responsectrlAgeRias);

        const map = parseCtrlAgeRias(responsectrlAgeRias);
        onCtrlAgeRiasReady(map);

        console.log("Parsed ctrlAgeRias map:", map);
      }
    } catch (error) {
      console.error("Errore durante il fetch degli appuntamenti:", error);
    }
  };

  return (
    <Grid
      container
      border={"1px solid #ccc"}
      p={2}
      gap={2}
      borderRadius={2}
      sx={{ display: "flex", justifyContent: "center" }}
    >
      <Grid
        item
        xs={12}
        gap={2}
        sx={{ display: "flex", justifyContent: "center" }}
      >
        {/* SELECT - Medico */}
        <Controller
          name="medico"
          control={control}
          rules={{ required: "Il campo medico è obbligatorio" }}
          render={({ field, fieldState }) => (
            <FormControl fullWidth size="small" error={!!fieldState.error}>
              <InputLabel id="medico-label">Selezionare Medico</InputLabel>
              <Select labelId="medico-label" label="Medico" {...field}>
                <MenuItem value="">
                  <em>Seleziona un medico</em>
                </MenuItem>
                {doctorList?.map((medico) => (
                  <MenuItem key={medico.CODICE} value={medico.CODICE}>
                    {medico.DESCRIZIONE}
                  </MenuItem>
                ))}
              </Select>
              {fieldState.error && (
                <Typography variant="caption" color="error">
                  {fieldState.error.message}
                </Typography>
              )}
            </FormControl>
          )}
        />
        <Controller
          name="sostituto"
          control={control}
          rules={{ required: "Il campo sostituto è obbligatorio" }}
          render={({ field, fieldState }) => (
            <FormControl fullWidth size="small" error={!!fieldState.error}>
              <InputLabel id="sostituto-label">
                Selezionare Sostituto
              </InputLabel>
              <Select labelId="sostituto-label" label="Sostituto" {...field}>
                <MenuItem value="">
                  <em>Seleziona un sostituto</em>
                </MenuItem>
                {doctorList?.map((medico) => (
                  <MenuItem key={medico.CODICE} value={medico.CODICE}>
                    {medico.DESCRIZIONE}
                  </MenuItem>
                ))}
              </Select>
              {fieldState.error && (
                <Typography variant="caption" color="error">
                  {fieldState.error.message}
                </Typography>
              )}
            </FormControl>
          )}
        />
      </Grid>
      <Grid
        item
        xs={12}
        gap={2}
        sx={{ display: "flex", justifyContent: "center" }}
      >
        <Controller
          name="appuntamentiDal"
          control={control}
          rules={{ required: "La data è obbligatoria" }}
          render={({ field, fieldState }) => (
            <FormControl fullWidth size="small" error={!!fieldState.error}>
              <TextField
                label="Appuntamenti dal"
                type="date"
                inputProps={{
                  min: dayjs().format("YYYY-MM-DD"),
                  max: "9999-12-31",
                }}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                {...field}
              />
              {fieldState.error && (
                <Typography variant="caption" color="error">
                  {fieldState.error.message}
                </Typography>
              )}
            </FormControl>
          )}
        />
        <Controller
          name="appuntamentiAl"
          control={control}
          rules={{ required: "La data è obbligatoria" }}
          render={({ field, fieldState }) => (
            <FormControl fullWidth size="small" error={!!fieldState.error}>
              <TextField
                label="Appuntamenti al"
                type="date"
                inputProps={{
                  min: dayjs().format("YYYY-MM-DD"),
                  max: "9999-12-31",
                }}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                {...field}
              />
              {fieldState.error && (
                <Typography variant="caption" color="error">
                  {fieldState.error.message}
                </Typography>
              )}
            </FormControl>
          )}
        />
      </Grid>

      <Grid item xs={12} display={"flex"} justifyContent={"flex-end"}>
        <Button variant="contained" onClick={handleSubmit(fetchAppointments)}>
          Ricerca
        </Button>
      </Grid>
    </Grid>
  );
};

const SpostamentoMassivo = (props: {
  setSpostamentoMassivoView: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [appuntamentiDaSpostare, setAppuntamentiDaSpostare] = useState<any>([]);
  const [appuntamentiSelezionati, setAppuntamentiSelezionati] = useState<
    AppointmentsToExtract[]
  >([]);
  const [sostituto, setSostituto] = useState<string>("");

  const [tipologiaOptions, setTipologiaOptions] = useState<string[]>([]);

  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  const [agendaPerApp, setAgendaPerApp] = useState<
    Record<
      string,
      {
        codTpgpre: string;
        idPgmedt: string;
        idMedpgm: string;
        codPgmedt: string;
        codAgendaGP: string;
      }
    >
  >({});

  const [showAllert, setShowAllert] = useState<boolean>(false);
  const [severity, setSeverity] = useState<string>("warning");
  const [message, setMessage] = useState<string>(
    "Confermi lo spostamento degli appuntamenti selezionati?"
  );
  const [openRicercaAgenda, setOpenRicercaAgenda] = useState(false);
  const [rowPerRicerca, setRowPerRicerca] =
    useState<AppointmentsToExtract | null>(null);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchEmpty, setLastSearchEmpty] = useState(false);

  // mappa info agenda per appuntamento (da ctrlAgeRias)
  const [ctrlAgeRiasById, setCtrlAgeRiasById] = useState<
    Record<
      string,
      {
        idAgenda?: string;
        codiceAgenda?: string;
        agendaGP?: string;
        segnalaAgenda: boolean;
      }
    >
  >({});

  const isActionDisabled = appuntamentiSelezionati.length === 0;

  const handleOpenRicercaAgenda = (row: AppointmentsToExtract) => {
    setRowPerRicerca(row);
    setOpenRicercaAgenda(true);
  };

  const resetAll = () => {
    setAppuntamentiDaSpostare([]);
    setAppuntamentiSelezionati([]);
    setSelectedIds([]);
    setAgendaPerApp({});
    setCtrlAgeRiasById({});
    setOpenRicercaAgenda(false);
    setRowPerRicerca(null);
    setShowAllert(false);
    setSeverity("warning");
    setMessage("Confermare la riassegnazione dei sospesi selezionati?");
    setSostituto("");
    setSearchDone(false);
    setLastSearchEmpty(false);
  };

  useEffect(() => {
    if (showAllert && severity !== "warning") {
      const timeout = setTimeout(() => {
        setShowAllert(false);
        setSeverity("warning");
        setMessage("Confermare la riassegnazione dei sospesi selezionati?");
      }, 4000);
      return () => clearTimeout(timeout);
    }
  }, [showAllert, severity]);

  const moveAppointments = async () => {
    if (isActionDisabled) return;

    const requestValues = {
      appuntamenti: appuntamentiSelezionati.map((app) => {
        const scelto = agendaPerApp[app.id];
        return {
          idPacada: app.id,
          codMedint: sostituto,
          codPgmedt: scelto?.codPgmedt ?? "",
          idPgmedt: scelto?.idPgmedt ?? "",
          idMedpgm: scelto?.idMedpgm ?? "",
          codTpgpre: scelto?.codTpgpre ?? "",
          codAgendaGP:
            scelto?.codAgendaGP ?? ctrlAgeRiasById[app.id]?.agendaGP ?? "",
          codAgenda: "",
        };
      }),
    };

    try {
      const response = await riassAppuntamenti(requestValues);
      const esito = response.data?.esito;

      if (esito === "OK") {
        setMessage(response.data.messaggio || "Riassegnazione completata");
        setSeverity("success");
        setTimeout(() => {
          resetAll();
        }, 400);
      } else {
        setMessage(response.data?.messaggio || "Errore nella riassegnazione");
        setSeverity("error");
      }
    } catch (error) {
      setMessage("Errore durante la riassegnazione. Riprova più tardi.");
      setSeverity("error");
    }
  };

  return (
    <>
      <Grid container sx={{ backgroundColor: "#F8F8F8", p: 3 }}>
        <AllertMessage
          showAllert={showAllert}
          setShowAllert={setShowAllert}
          severity={severity}
          message={message}
          submitFunction={moveAppointments}
          // showSummary={props.handleSummaryTableOpening}
        />
        <Grid item xs={12} mb={2}>
          <Typography sx={{ fontWeight: "bold" }}>
            Spostamento massivo prenotazioni
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Tabs value={selectedTab} onChange={() => setSelectedTab(0)}>
            <Tab
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                textTransform: "none",
              }}
              label="Dettaglio"
            />
          </Tabs>
        </Grid>
        <Grid item xs={12} pt={3} pb={1}>
          <Typography sx={{ fontWeight: "bold", color: "#00000099" }}>
            Ricerca prenotazioni
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ display: "flex" }} pr={2}>
          <RicercaPrenotazioni
            setAppuntamenti={setAppuntamentiDaSpostare}
            setSostituto={setSostituto}
            onCtrlAgeRiasReady={(map) => setCtrlAgeRiasById(map)}
            onSearchResult={({ searched, empty }) => {
              setSearchDone(searched);
              setLastSearchEmpty(empty);
            }}
            onTypologyOptions={(opts) => setTipologiaOptions(opts)}
          />
        </Grid>
        <Grid
          item
          xs={12}
          mt={2}
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignContent: "center",
          }}
        >
          <Typography sx={{ fontWeight: "bold", color: "#00000099" }}>
            Prenotazioni da Spostare
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ display: "flex", height: 200 }} mt={2}>
          {searchDone && lastSearchEmpty ? (
            <Box
              sx={{ width: "100%", display: "flex", flexDirection: "column" }}
            >
              <Alert
                severity="warning"
                role="status"
                aria-live="polite"
                sx={{
                  justifyContent: "center",
                  border: "1px solid #e65100",
                  maxHeight: "56px",
                  alignContent: "center",
                  alignItems: "center",
                  "& .MuiAlert-icon": { ml: 2, fontSize: 40 },
                }}
              >
                <Box>
                  <Typography
                    component="div"
                    mt={"12px"}
                    ml={"20px"}
                    mr={"10px"}
                    mb={"12px"}
                    fontSize={"16px"}
                    fontWeight={"bold"}
                  >
                    Nessun appuntamento disponibile per i filtri selezionati.
                  </Typography>
                </Box>
              </Alert>
            </Box>
          ) : (
            <AppuntamentiDaSpostare
              rows={appuntamentiDaSpostare}
              onSelectionChange={setAppuntamentiSelezionati}
              onOpenRicercaAgenda={handleOpenRicercaAgenda}
              alertById={Object.fromEntries(
                Object.entries(ctrlAgeRiasById).map(([id, v]) => {
                  const hasManualChoice = !!agendaPerApp[id];
                  const warn = !!v.segnalaAgenda;
                  return [id, hasManualChoice ? false : warn];
                })
              )}
              selectedIds={selectedIds}
              onSelectedIdsChange={(ids: any) => {
                setSelectedIds(ids);
                const selectedRows = appuntamentiDaSpostare.filter((r: any) =>
                  ids.includes(r.id)
                );
                setAppuntamentiSelezionati(selectedRows);
              }}
            />
          )}
          <RicercaAgendaModal
            open={openRicercaAgenda}
            onClose={() => setOpenRicercaAgenda(false)}
            initialFilters={{
              medicoSostituto: sostituto,
              prestazione: rowPerRicerca?.prestazioneCod ?? "",
              tipologia: rowPerRicerca?.tipologia ?? "",
            }}
            selectedRow={rowPerRicerca}
            onConfirm={(agenda) => {
              setOpenRicercaAgenda(false);
              if (!agenda || !rowPerRicerca) return;

              const id = rowPerRicerca.id;
              setAgendaPerApp((prev) => ({
                ...prev,
                [id]: {
                  codTpgpre: agenda.codTpgpre,
                  idPgmedt: agenda.idPgmedt,
                  idMedpgm: agenda.idMedpgm,
                  codPgmedt: agenda.codPgmedt,
                  codAgendaGP: agenda.codAgendaGP,
                },
              }));
              setSelectedIds((prev) =>
                prev.includes(id) ? prev : [...prev, id]
              );

              setAppuntamentiSelezionati((prev) => {
                const map = new Map(prev.map((r) => [r.id, r]));
                const justSelected = appuntamentiDaSpostare.find(
                  (r: any) => r.id === id
                );
                if (justSelected) map.set(id, justSelected);
                return Array.from(map.values()).filter(
                  (r) => selectedIds.includes(r.id) || r.id === id
                );
              });
            }}
          />
        </Grid>
        <Grid item xs={12} mt={2}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Button
                variant="outlinedError"
                onClick={() => {
                  resetAll();
                  props.setSpostamentoMassivoView(false);
                }}
              >
                Uscita
              </Button>
            </Grid>
            <Grid item>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Button
                  variant="contained"
                  onClick={() => setShowAllert(true)}
                  disabled={isActionDisabled}
                >
                  Sostituisci
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const BookingCalendar = () => {
  const date = new Date();
  const currentDate = dayjs(); //data attuale
  const currentYear = currentDate.year(); // Anno corrente
  const currentMonth = currentDate.month(); // Mese corrente (0-based index)
  const currentWeek =
    currentDate.isoWeek() -
    dayjs(`${currentYear}-01-01`).startOf("isoWeek").isoWeek() +
    1;

  const [selectedDate, setSelectedDate] = useState<string>(
    currentDate.format("YYYY-MM-DD")
  );

  //console.log({ selectedDate });

  const [structures, setStructuresList] = useState<Location[]>([]);
  const [selectedView, setSelectedView] = useState<string>("timeGridDay"); //Stato per gestire le viste del calendario
  const [dataAppointments, setDataAppointments] = useState<AppointmentData[]>(
    []
  ); //Salvo i dati dalla fetch
  const [appointmentsByAgenda, setAppointmentsByAgenda] = useState<
    AppointmentData[]
  >([]); //Salvo gli appuntamenti in base all'agenda
  const [openModal, setOpenModal] = useState(false); //Booleano per aprire il modale e chiuderlo
  const [selectedAppointment, setSelectedAppointment] = useState<any>(null); // Appuntamento selezionato
  const [year, setYear] = useState(currentYear); // Anno
  const [month, setMonth] = useState(currentMonth); // Mese
  const [week, setWeek] = useState(currentWeek); // Settimana
  const [weeksInMonth, setWeeksInMonth] = useState<
    { week: number; start: string; end: string }[]
  >([]); //Settimane del mese
  const [agendaType, setAgendaType] = useState<string[]>([]);
  // Stato per tenere traccia delle checkbox selezionate
  const [selectedAgendas, setSelectedAgendas] = useState<string[]>([]);
  const [filteredSpecialties, setFilteredSpecialties] = useState<string[]>([]);
  const [filteredDoctors, setFilteredDoctors] = useState<string[]>([]);
  const [filteredCompanies, setFilteredCompanies] = useState<string[]>([]);
  //Stato per tenere traccia delle agende selezionate nella vista mese e/o giorno
  const [agendaClicked, setAgendaClicked] = useState<string | null>(null);
  const [parametriTabellone, setParametriTabellone] = useState<any>(null); // Stato per i parametri del tabellone
  const [indisponibilita, setIndisponibilita] = useState<any[]>([]);
  const [disponibilita, setDisponibilita] = useState<any[]>([]);
  const [spostamentoMassivoView, setSpostamentoMassivoView] =
    useState<boolean>(false);
  const [showNoAppointmentsFound, setShowNoAppointmentsFound] =
    useState<boolean>(false);

  // Ottiene il tema globale di Material UI, utile per accedere ai breakpoints definiti
  const theme = useTheme();

  // Determina se la visualizzazione è su un dispositivo mobile (schermo più piccolo di 600px)
  // Restituisce true per mobile e false per tablet/desktop
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleOpenModal = (appointment: any) => {
    setSelectedAppointment(appointment); // Salva l'appuntamento selezionato
    setOpenModal(true); // Apre il modale
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Chiude il modale
    setSelectedAppointment(null); // Resetta l'appuntamento selezionato
  };

  // Riferimento per FullCalendar
  const calendarRef = useRef<any>(null);

  //ueForm tiene sempre aggiornati i valori che fanno parte delle input/select ecc
  const { control, getValues, setValue, watch } = useForm<CommonFieldsData>({
    defaultValues: {
      idPaziente: "",
      // nominativo:"", QUESTO ANDRA' RIPRISTINATO
      cognomePaziente: "",
      nomePaziente: "",
      cfPaziente: "",
      dataNasPaziente: "",
      specialita: "",
      tipoDate: "V",
      dataIni: "",
      dataFin: "",
      numPrenotazione: "",
      impegnativa: "",
      origine: "",
      tipoCodSISS: "",
      codSISS: "",
      ricercaId: "",
      tipoApp: "A",
      aziende: [],
    },
  });

  useEffect(() => {
    if (getValues("dataIni") === "") {
      setValue("dataIni", currentDate.format("YYYY-MM-DD"));
      setValue("dataFin", currentDate.format("YYYY-MM-DD"));
    }
  }, [getValues("dataIni")]);

  //Il watch tiene conto del continuo cambiamento dei valori dei campi selezionati (una sorta di state)
  const medico = watch("medico");
  const specialita = watch("specialita");
  const azienda = watch("aziende");

  // Con AuthGuard, l'utente e' gia' autenticato quando raggiunge questa pagina
  useEffect(() => {
    const fetchStructures = async () => {
      const responseStructures = await locations({
        tipoAgenda: "",
        listino: "",
        specialita: "",
        prestazione: "",
        medico: [],
        dataInizio: "",
        dataFine: "",
      });

      const dati = responseStructures.data?.dati;

      //Serve fare questo passaggio perché l'api restituisce un oggetto tipo { meditel: {Descrione: ""}} ecc.
      const structuresArray: Location[] = Object.entries(dati || {}).map(
        ([id, value]: [string, any]) => ({
          id,
          descrizione: value?.DESCRIZIONE ?? "",
        })
      );
      setStructuresList(structuresArray);

      setValue(
        "aziende",
        structuresArray.map((location) => location.id),
        { shouldDirty: false }
      );
    };
    fetchStructures();
    handleAppointmentByDate(selectedView);
  }, []);

  //Serve per evitare problemi grafici dovuti dal passaggio da spostamentoMassivo a BookingCalendar
  useEffect(() => {
    if (!spostamentoMassivoView) {
      const defaultView = "timeGridDay";

      setSelectedView(defaultView);
      setValue("medico", "");
      setValue("specialita", "");
      setSelectedAgendas([]);
      setAgendaClicked(null);

      setIndisponibilita([]);
      setDisponibilita([]);

      // Cambia la vista e forza la fetch
      if (calendarRef.current) {
        calendarRef.current.getApi().changeView(defaultView);
        calendarRef.current.getApi().gotoDate(selectedDate);
      }

      handleAppointmentByDate(defaultView);
    }
  }, [spostamentoMassivoView]);

  // Funzione per effettuare la chiamata all'API
  const handleAppointmentByDate = async (viewType: string) => {
    //Prendo i valori dai campi delle select/input
    const dataValues = getValues();
    console.log({ dataValues });

    //Controllo che il calendario ci sia e mi restituisca qualcosa
    if (calendarRef.current) {
      const currentDate = calendarRef.current.calendar.currentData.currentDate; //Recupero la data attuale dal calendario
      const selectedDateObj = new Date(currentDate);
      const romeTimeZone = "Europe/Rome";

      if (viewType.includes("dayGridMonth")) {
        // Gestione per la vista Mensile
        const startOfMonthDate = startOfMonth(selectedDateObj); //Primo giorno del mese
        const endOfMonthDate = endOfMonth(selectedDateObj); //Ultimo giorno del mese
        const startDateInRome = toZonedTime(startOfMonthDate, romeTimeZone); //Formato italiano
        const endDateInRome = toZonedTime(endOfMonthDate, romeTimeZone); //Formato italiano

        dataValues.dataIni = format(startDateInRome, "yyyy-MM-dd"); //Formatto la data per anno-mese-giorno
        dataValues.dataFin = format(endDateInRome, "yyyy-MM-dd");
      } else if (viewType.includes("dayGridWeek")) {
        //console.log("Sono nella vista settimanale");

        // Gestione per la vista Settimanale
        const day = selectedDateObj.getDay(); //Prendo la data attuale
        //Calcolo le giornate dal lunedì alla domenica e faccio partire lunedì come primo giorno della settimana
        const diffToMonday =
          selectedDateObj.getDate() - day + (day === 0 ? -6 : 1);
        const monday = new Date(selectedDateObj.setDate(diffToMonday));
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);

        dataValues.dataIni = monday.toISOString().split("T")[0];
        dataValues.dataFin = sunday.toISOString().split("T")[0];
      } else if (
        viewType.includes("timeGridDay") ||
        viewType.includes("resourceTimelineDay")
      ) {
        const startOfDay = format(selectedDateObj, "yyyy-MM-dd");
        const endOfDay = format(selectedDateObj, "yyyy-MM-dd");
        // Gestione per la vista Giornaliera
        dataValues.dataIni = startOfDay;
        dataValues.dataFin = endOfDay;
      } else if (
        viewType.includes("listDay") ||
        viewType.includes("timeGridDay")
      ) {
        // Gestione per la vista Lista
        const startOfDay = format(selectedDateObj, "yyyy-MM-dd");
        const endOfDay = format(selectedDateObj, "yyyy-MM-dd");

        dataValues.dataIni = startOfDay;
        dataValues.dataFin = endOfDay;

        // Se la vista è settimanale, calcola i confini della settimana
        // if (viewType.includes("listWeek")) {
        //   const day = selectedDateObj.getDay();
        //   const diffToMonday =
        //     selectedDateObj.getDate() - day + (day === 0 ? -6 : 1);
        //   const monday = new Date(selectedDateObj.setDate(diffToMonday));
        //   const sunday = new Date(monday);
        //   sunday.setDate(monday.getDate() + 6);

        //   dataValues.dataIni = format(monday, "yyyy-MM-dd");
        //   dataValues.dataFin = format(sunday, "yyyy-MM-dd");
        // } else {
        //   dataValues.dataIni = startOfDay;
        //   dataValues.dataFin = endOfDay;
        // }

        //console.log(`Vista Lista: Inizio/Fine: ${dataValues.dataIni}`);
      }

      if (dataValues.medico?.length === 0) {
        dataValues.medico = "";
      }

      try {
        const response = await appointmentResearchNew(dataValues);
        const data = response.data?.dati;

        if (data) {
          console.log("dati: ", data);

          setParametriTabellone(data.parametriTabellone);

          console.log("parametri tabellone: ", data.parametriTabellone);

          if (data.indisponibilita) {
            console.log("Indisponibilità:", data.indisponibilita);
            setIndisponibilita(data.indisponibilita);
          } else {
            setIndisponibilita([]);
          }

          if (data.agendeAperte) {
            console.log("Disponibilità:", data.agendeAperte);
            setDisponibilita(data.agendeAperte);
          } else {
            setDisponibilita([]);
          }

          //Filtro la response dell'api in un array dove non ci sono le chiavi listaMedici e listaSpecialità
          //e li inserisco in un nuovo array
          let appointments = Object.keys(data)
            .filter(
              (key) =>
                key !== "listaMedici" &&
                key !== "listaSpecialita" &&
                key !== "parametriTabellone" &&
                key !== "agendeAperte" &&
                key !== "indisponibilita"
            )
            .reduce((acc, key) => {
              const appointment = data[key];
              if (appointment && Object.keys(appointment).length > 0) {
                acc.push(appointment);
              }
              return acc;
            }, [] as any[]);

          let flatAppointment = (
            Object.values(appointments) as AppointmentData[][]
          ).flatMap((element) => element.flat());

          console.log("appointments: ", flatAppointment);

          const availableAppointments = flatAppointment.filter((key) => {
            return (
              key.STATOPRENOTAZIONE !== "Cancellata" &&
              key.STATOPRENOTAZIONE !== "Annullata"
            );
          });

          if (availableAppointments.length > 0) {
            setDataAppointments(availableAppointments);

            //Suddivido gli appuntamenti in base al tipo di agenda e li inserisco tutti in nuovi array
            //basati per tipo di agenda
            const groups = availableAppointments.reduce(
              (acc: any, appuntamento: AppointmentData) => {
                const TIPOAGENDA = appuntamento.TIPOAGENDA;

                // console.log({ appuntamento });

                // console.log({ TIPOAGENDA });
                // console.log(acc);

                if (!acc[TIPOAGENDA]) {
                  acc[TIPOAGENDA] = [];
                }
                acc[TIPOAGENDA].push(appuntamento);

                return acc;
              },
              {}
            );
            setAppointmentsByAgenda(groups);
            console.log({ groups });

            const agendaNames = (
              Object.values(groups) as AppointmentData[][]
            ).flatMap((element) =>
              element.flat().map((appointment) => appointment.TIPOAGENDA)
            );
            // console.log("Agenda Names:", agendaNames);

            const prova = [...new Set(agendaNames)];

            setAgendaType(prova);
          } else {
            setDataAppointments([]);
            setAppointmentsByAgenda([]);
            setAgendaType([]);
            setShowNoAppointmentsFound(true);
          }

          //console.log("Lista appuntamenti", appointments);
        } else {
          console.warn("Nessun dato disponibile per gli appuntamenti.");
          setDataAppointments([]);
          setAppointmentsByAgenda([]);
          setAgendaType([]);
        }
      } catch (error) {
        console.error("Errore durante la chiamata API:", error);
      }
    }
  };

  useEffect(() => {
    // Se medici e specialità sono undefined li inizializzo come array vuoti
    const selectedMedici = medico ?? [];
    const selectedSpecialita = specialita ?? "";
    const selectedAziende = azienda ?? [];

    // Filtro le specialità in base ai medici selezionati
    if (selectedMedici.length > 0) {
      const specialties = dataAppointments
        .filter(
          (appointment) =>
            selectedMedici.includes(appointment.CODMEDICO) &&
            appointment.DATAESAME === selectedDate // Filtra per la data selezionata
        )
        .map((appointment) => appointment.DESCRSPECIALITA);

      setFilteredSpecialties([...new Set(specialties)]);
    } else {
      const allSpecialties = dataAppointments
        .filter((appointment) => appointment.DATAESAME === selectedDate)
        .map((appointment) => appointment.DESCRSPECIALITA);

      setFilteredSpecialties([...new Set(allSpecialties)]);
    }

    // Filtro i medici in base alla specialità selezionata
    if (selectedSpecialita) {
      const doctors = dataAppointments
        .filter(
          (appointment) =>
            appointment.DESCRSPECIALITA === selectedSpecialita &&
            appointment.DATAESAME === selectedDate
        )
        .map((appointment) => appointment.CODMEDICO);

      setFilteredDoctors([...new Set(doctors)]);
    } else {
      setFilteredDoctors([
        ...new Set(
          dataAppointments
            .filter((appointment) => appointment.DATAESAME === selectedDate)
            .map((appointment) => appointment.CODMEDICO)
        ),
      ]);
    }

    // CODICE CHE NON SERVE?
    // if (selectedAziende.length > 0) {
    //   const companies = dataAppointments
    //     .filter(
    //       (company) => {
    //         console.log({company});
    //         return selectedAziende.includes(company.AZIENDAPRENOTAZIONE) &&
    //         company.DATAESAME === selectedDate
    //       }
    //     )
    //     .map((company) => {
    //       return `${company.AZIENDAPRENOTAZIONE}`});

    //   setFilteredCompanies([...new Set(companies)]);
    // } else {
    //   const allCompanies = dataAppointments
    //     .filter((company) => company.DATAESAME === selectedDate)
    //     .map((company) => company.AZIENDAPRENOTAZIONE);

    //   setFilteredCompanies([...new Set(allCompanies)]);
    // }
  }, [medico, specialita, azienda, dataAppointments, selectedDate]);

  // Nuovo useEffect per filtrare le agende in base ai medici selezionati
  useEffect(() => {
    const selectedMedici = medico ?? [];

    if (selectedMedici.length > 0) {
      // Filtra gli appuntamenti basandoti sui medici selezionati
      const agendasFilteredByDoctor = Array.from(
        new Set(
          dataAppointments
            .filter((appointment) =>
              selectedMedici.includes(appointment.CODMEDICO)
            )
            .map((appointment) => appointment.TIPOAGENDA)
        )
      );

      // Aggiorna gli agenda disponibili basati sul medico selezionato
      setAgendaType(agendasFilteredByDoctor);

      // Se un'agenda selezionata non è più disponibile, la rimuoviamo da selectedAgendas
      setSelectedAgendas((prevSelectedAgendas) =>
        prevSelectedAgendas.filter((agenda) =>
          agendasFilteredByDoctor.includes(agenda)
        )
      );
    } else {
      // Se non ci sono medici selezionati, mostra tutte le agende disponibili per il giorno selezionato
      const allAvailableAgendas = Array.from(
        new Set(dataAppointments.map((appointment) => appointment.TIPOAGENDA))
      );
      setAgendaType(allAvailableAgendas);
    }
  }, [medico, dataAppointments]);

  //Quando clicco sul pulsante per andare avanti di giorno/mese/settimana rieseguo la fetch e aggiorno il calendario
  const handleNextClick = () => {
    if (calendarRef.current) {
      const api = calendarRef.current.getApi();
      api.next(); // Cambia la vista alla successiva
      const viewType = api.view.type;

      const currentDate = api.getDate(); // Ottieni la nuova data

      // Aggiorna la settimana solo se la vista è dayGridWeek
      if (viewType === "dayGridWeek" || viewType === "dayGridMonth") {
        const newMonth = currentDate.getMonth(); // Mese (0-based)
        const newYear = currentDate.getFullYear(); // Anno

        // Aggiorna mese e anno
        setMonth(newMonth);

        setYear(newYear);
        const updatedWeeks = getWeeksOfMonth(newYear, newMonth);
        const currentWeekISO = dayjs(currentDate).isoWeek();

        const currentWeek = updatedWeeks.find(
          (w) => dayjs(w.start).isoWeek() === currentWeekISO
        );

        if (currentWeek) {
          setWeek(currentWeek.week); // Aggiorna la settimana selezionata
          setWeeksInMonth(updatedWeeks); // Aggiorna le settimane disponibili
        } else {
          console.warn("Nessuna settimana corrente trovata.");
        }
      }

      setValue("medico", ""); // Reset medico
      setValue("specialita", ""); // Reset specialità

      if (viewType !== selectedView) {
        setSelectedView(viewType);
        handleAppointmentByDate(viewType);
      }
    }
  };

  //Quando clicco sul pulsante per andare indietro di giorno/mese/settimana rieseguo la fetch e aggiorno il calendario
  const handlePrevClick = () => {
    if (calendarRef.current) {
      const api = calendarRef.current.getApi();
      api.prev(); // Cambia la vista alla precedente
      const viewType = api.view.type;

      const currentDate = api.getDate(); // Ottieni la nuova data
      if (viewType === "dayGridWeek" || viewType === "dayGridMonth") {
        const newMonth = currentDate.getMonth(); // Mese (0-based)
        const newYear = currentDate.getFullYear(); // Anno

        // Aggiorna mese e anno
        setMonth(newMonth);

        setYear(newYear);
        const updatedWeeks = getWeeksOfMonth(newYear, newMonth);
        const currentWeekISO = dayjs(currentDate).isoWeek();

        const currentWeek = updatedWeeks.find(
          (w) => dayjs(w.start).isoWeek() === currentWeekISO
        );

        if (currentWeek) {
          setWeek(currentWeek.week); // Aggiorna la settimana selezionata
          setWeeksInMonth(updatedWeeks); // Aggiorna le settimane disponibili
        } else {
          console.warn("Nessuna settimana corrente trovata.");
        }
      }

      setValue("medico", ""); // Reset medico
      setValue("specialita", ""); // Reset specialità

      if (viewType !== selectedView) {
        setSelectedView(viewType);
        handleAppointmentByDate(viewType);
      }
    }
  };

  useEffect(() => {
    if (calendarRef.current && selectedView === "dayGridWeek") {
      const api = calendarRef.current.getApi();
      const startDate = weeksInMonth.find((w) => w.week === week)?.start;
      if (startDate) {
        api.gotoDate(startDate);
      }
    }
  }, [week, selectedView, weeksInMonth]);

  //Funzione per gestire il pulsante "Oggi" in modo da aggiornare le date inserite nelle select/input quando viene premuto
  const handleTodayClick = () => {
    if (calendarRef.current) {
      // console.log("Inizio handleTodayClick");

      const api = calendarRef.current.getApi();

      console.log("API", api);

      const currentDate = new Date(); // Data attuale con oggetto JavaScript
      const formattedDate = dayjs(currentDate).format("YYYY-MM-DD"); // Data formattata

      console.log("Data attuale calcolata:", formattedDate);

      // Imposta la data corrente nel calendario
      api.gotoDate(formattedDate);

      // console.log({
      //   currentDate: api.getDate(),
      //   viewType: api.view.type,
      //   viewTitle: api.view.title,
      //   visibleRange: {
      //     start: api.view.activeStart?.toISOString(),
      //     end: api.view.activeEnd?.toISOString(),
      //   },
      // });

      // Aggiorna lo stato locale
      const updatedWeeks = getWeeksOfMonth(
        currentDate.getFullYear(),
        currentDate.getMonth()
      );
      const currentWeekISO = dayjs(currentDate).isoWeek();
      const currentWeek = updatedWeeks.find(
        (w) => dayjs(w.start).isoWeek() === currentWeekISO
      );

      if (currentWeek) {
        // console.log("Settimana corrente trovata:", currentWeek);
        setWeek(currentWeek.week);
        setYear(currentDate.getFullYear());
        setMonth(currentDate.getMonth());
      } else {
        console.warn("Nessuna settimana corrente trovata.");
      }
      // console.log("Fine handleTodayClick");
    }
  };

  const formatHour = (time: any) => {
    if (!time || typeof time !== "string") {
      return ""; // Restituisce un valore di fallback se il tempo è indefinito o non è un numero
    }

    // Converte il numero in una stringa con zeri iniziali (se necessario)
    const timeString = time.toString().padStart(4, "0");

    // Prende le prime due cifre come ore e le ultime due come minuti
    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    // Restituisce l'orario formattato come HH:mm
    return `${hours}:${minutes}`;
  };

  // Funzione per mostrare le agende nel calendario con il numero totale degli appuntamenti
  const renderEventContent = (eventInfo: any) => {
    const classNames: string[] = eventInfo.event.classNames ?? [];
    const isIndisponibile = classNames.includes("indisponibile");
    const isDisponibile = classNames.includes("disponibile");

    // Caso disponibilità e/o indisponibilità medico nello Scheduler
    // (per ora gestiamo solo le indisponibilità su richiesta)
    if (isIndisponibile || isDisponibile) {
      const startTime = eventInfo.event.start
        ? dayjs(eventInfo.event.start).format("HH:mm")
        : "";
      const endTime = eventInfo.event.end
        ? dayjs(eventInfo.event.end).format("HH:mm")
        : "";

      const timeRange =
        startTime && endTime
          ? `${startTime} - ${endTime}`
          : startTime || endTime || "Orario non disponibile";

      const tooltipTitle = `${
        isIndisponibile ? "Indisponibilità" : "Disponibilità"
      } medico (${timeRange})`;

      return (
        <Tooltip
          title={tooltipTitle}
          arrow
          followCursor
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: 14,
                padding: "8px 12px",
              },
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              height: "100%",
              minHeight: 8,
              display: "flex",
              alignItems: "stretch",
            }}
          >
            <span style={{ opacity: 0 }}>.</span>
          </Box>
        </Tooltip>
      );
    }

    //Caso con gli appuntamenti
    const rawTitle: string = eventInfo.event.title || "";
    const truncateString =
      rawTitle.length > 80 ? rawTitle.slice(0, 80).trimEnd() + "..." : rawTitle;
    const [agendaType, appointmentsCount] = truncateString.split("\n");

    return (
      <Tooltip title={rawTitle ?? ""} arrow>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "12px",
            maxWidth: "300px",
            height:
              selectedView === "timeGridDay" ||
              selectedView === "resourceTimelineDay"
                ? "auto"
                : "50px",
          }}
        >
          <Box
            sx={{
              fontWeight: "bold",
              color: "black",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              width: "100%",
              textAlign: "center",
            }}
          >
            {agendaType}
          </Box>

          {appointmentsCount && (
            <span style={{ color: "black" }}>{appointmentsCount}</span>
          )}
        </Box>
      </Tooltip>
    );
  };

  //Funzione che viene eseguita quando viene cambiata la data nel calendario (Utilizzo il blur in modo che la data non cambi subito)
  //Ma solo quando l'utente non seleziona più una data
  const handleDateBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const newDate = event.target.value;
    if (newDate && !isNaN(new Date(newDate).getTime())) {
      // Aggiorna lo stato della data e sposta il calendario
      setSelectedDate(newDate);

      if (calendarRef.current) {
        calendarRef.current.getApi().gotoDate(newDate); // Sposta il calendario alla nuova data
      }

      // Esegui la chiamata test con la vista corrente
      handleAppointmentByDate(selectedView);
    } else {
      console.error("Data non valida inserita:", newDate);
    }
  };

  useEffect(() => {
    if (selectedView === "dayGridWeek") {
      goToSelectedWeek();
    }

    //Se la vista è giornaliera o scheduler, imposto l'ora di partenza a quella corrente
    if (
      selectedView === "resourceTimelineDay" ||
      selectedView === "timeGridDay"
    ) {
      updateScrollTime();
    }

    // Se siamo passati a "listDay" e c’è un'agenda salvata da un click precedente
    if (selectedView === "listDay" && agendaClicked) {
      setSelectedAgendas([agendaClicked]);
      setAgendaClicked(null); // Reset per non applicarlo di nuovo
    }

    // debouncedHandleAppointmentByDate(selectedView);
  }, [selectedView, medico, specialita, azienda, week, month, year]);

  // Controllo periodico dei filtri delle agende in base alla vista corrente e agli appuntamenti disponibili
  useEffect(() => {
    // Inizializzo con tutti gli appuntamenti
    let relevantAppointments = dataAppointments;

    // Se la vista è giornaliera o scheduler, filtro solo per la data selezionata
    if (
      ["listDay", "timeGridDay", "resourceTimelineDay"].includes(selectedView)
    ) {
      relevantAppointments = dataAppointments.filter(
        (appointment) => appointment.DATAESAME === selectedDate
      );
    }

    // Estraggo tutte le agende uniche dagli appuntamenti rilevanti
    const agendas = [...new Set(relevantAppointments.map((a) => a.TIPOAGENDA))];

    // Aggiorno lo stato agendaType con le agende disponibili
    setAgendaType(agendas);

    // Mantengo selezionate solo le agende ancora disponibili
    setSelectedAgendas((prevSelected) =>
      prevSelected.filter((agenda) => agendas.includes(agenda))
    );
  }, [selectedView, selectedDate, dataAppointments]);

  //Funzione per gestire gli eventi in base alla vista selezionata
  const handleEvents = () => {
    // Inizializzo l'array degli eventi
    let events: any[] = [];

    // Filtraggio degli appuntamenti in base alle agende selezionate
    const filteredAppointments = dataAppointments.filter((appointment) =>
      selectedAgendas.length > 0
        ? selectedAgendas.includes(appointment.TIPOAGENDA)
        : true
    );

    // Se la vista è giornaliera, lista o scheduler
    if (
      selectedView === "timeGridDay" ||
      selectedView === "listDay" ||
      selectedView === "resourceTimelineDay"
    ) {
      const dataValues = getValues();

      const furtherFilteredAppointments = filteredAppointments.filter(
        (appointment) => {
          const doctorCondition =
            dataValues.medico?.length === 0 ||
            dataValues.medico?.includes(appointment.CODMEDICO);

          const specialityCondition = dataValues.specialita
            ? appointment.DESCRSPECIALITA === dataValues.specialita
            : true;

          const companyCondition =
            !azienda || azienda.length === 0
              ? true
              : azienda.includes(appointment.AZIENDAPRENOTAZIONE);

          return doctorCondition && specialityCondition && companyCondition;
        }
      );

      // funzione per formattare su un unica riga gli orari che arrivano da api /ricDisp e raggruppati per disponibilita/indisponibilita
      const formatArrayDoctorAvailability = (eventsAvailability: any[]) => {
        const dateAvailabilityByMedico = eventsAvailability?.reduce(
          (acc, curr) => {
            if (!acc[curr.medicoId]) {
              acc[curr.medicoId] = {
                id: curr.id,
                start: curr.start,
                end: curr.end,
                agenda: curr.agenda,
                resourceId: curr.resourceId,
                medicoId: curr.medicoId,
                className: curr.className,
              };
            } else {
              if (dayjs(curr.start).isBefore(dayjs(acc[curr.medicoId].start))) {
                acc[curr.medicoId].start = curr.start;
              }

              if (dayjs(curr.end).isAfter(dayjs(acc[curr.medicoId].end))) {
                acc[curr.medicoId].end = curr.end;
              }
            }
            return acc;
          },
          {} as Record<
            string,
            {
              id: string;
              start: string;
              end: string;
              agenda?: string;
              resourceId: string;
              medicoId: string;
              className: string;
            }
          >
        );

        const groupedaArr = Object.values(dateAvailabilityByMedico ?? {}).map(
          (e: any) => ({
            id: e.id,
            start: e.start,
            end: e.end,
            resourceId: String(e.resourceId),
            className: e.className,
          })
        );

        return groupedaArr;
      };

      // Appuntamenti formattati come eventi
      const appointmentEvents = furtherFilteredAppointments.map(
        (appointment) => {
          const startTime = `${appointment.DATAESAME}T${formatHour(
            appointment.ORAESAME
          )}`;
          const duration = parseInt(appointment.DURATAESAME, 10); // Durata in minuti
          const endTime = dayjs(startTime)
            .add(duration, "minute")
            .format("YYYY-MM-DDTHH:mm:ss");

          return {
            title: `${appointment.DESCRESAME} - Dr: ${appointment.NOMEMEDICO} - Paziente: ${appointment.COGNOMEPAZIENTE} ${appointment.NOMEPAZIENTE}`,
            start: startTime,
            end: endTime,
            resourceId: appointment.NOMEMEDICO,
            className: appointment.TIPOAGENDA
              ? `agenda-${appointment.TIPOAGENDA.toLowerCase()}`
              : "",
            extendedProps: {
              description: appointment.DESCRESAME || "Nessuna descrizione",
              medico: appointment.NOMEMEDICO,
              durataEsame: appointment.DURATAESAME,
              oraEsame: appointment.ORAESAME,
              codicePrenotazione: appointment.PRENOTAZIONE,
              dataPrenotazione: appointment.DATAPRENOTAZIONE,
              tipoAgenda: appointment.TIPOAGENDA,
              noteEsame: appointment.NOTEESAME,
              nomePaziente: appointment.NOMEPAZIENTE,
              cognomePaziente: appointment.COGNOMEPAZIENTE,
              aziendaPrenotazione: appointment.AZIENDAPRENOTAZIONE,
            },
          };
        }
      );

      events.push(...appointmentEvents);

      // Aggiungo indisponibilità solo nello Scheduler
      if (selectedView === "resourceTimelineDay") {
        const indisponibilitaEvents = indisponibilita
          .filter(
            (item) =>
              item.ORADA && item.ORADA !== "0" && item.ORAA && item.ORAA !== "0"
          )
          .map((item, index) => {
            const startTime = `${selectedDate}T${formatHour(item.ORADA)}`;
            const endTime = `${selectedDate}T${formatHour(item.ORAA)}`;

            return {
              id: `indisponibilita-${index}`,
              start: startTime,
              end: endTime,
              resourceId: item.NOMEMEDICO,
              medicoId: item.IDMEDICO,
              className: "indisponibile",
            };
          });

        const disponibilitaEvents = disponibilita
          .filter(
            (item) =>
              item.B1ORADA &&
              item.B1ORADA !== "0" &&
              item.B1ORAA &&
              item.B1ORAA !== "0"
          )
          .map((item, index) => {
            const startTime = `${selectedDate}T${formatHour(item.B1ORADA)}`;
            const endTime = `${selectedDate}T${formatHour(item.B1ORAA)}`;

            return {
              id: `disponibilita-${index}`,
              start: startTime,
              end: endTime,
              agenda: item.CODICEAGENDA,
              resourceId: item.NOMEMEDICO,
              medicoId: item.IDMEDICO,
              className: "disponibile",
            };
          });

        const groupedDisponibilitaArrTest =
          formatArrayDoctorAvailability(disponibilitaEvents);
        const groupedIndisponibilitaArrTest = formatArrayDoctorAvailability(
          indisponibilitaEvents
        );

        events.push(
          ...groupedDisponibilitaArrTest,
          ...groupedIndisponibilitaArrTest
        );
      }

      return events;
    }

    // Vista aggregata (es. mese o settimana): raggruppa per giorno + agenda
    return Object.entries(
      filteredAppointments.reduce<{
        [key: string]: { [key: string]: AppointmentData[] };
      }>((acc, appointment) => {
        const { TIPOAGENDA, DATAESAME } = appointment;
        if (!acc[DATAESAME]) {
          acc[DATAESAME] = {};
        }
        if (!acc[DATAESAME][TIPOAGENDA]) {
          acc[DATAESAME][TIPOAGENDA] = [];
        }
        acc[DATAESAME][TIPOAGENDA].push(appointment);
        return acc;
      }, {})
    ).flatMap(([date, agendas]) =>
      Object.entries(agendas).map(([agendaType, appointments]) => ({
        title: `${agendaType}\n${appointments.length} appuntamenti`,
        start: `${date}T08:00:00`,
        className: `agenda-${agendaType.toLowerCase()}`,
        resourceId: agendaType,
        extendedProps: {
          description: `Totale appuntamenti: ${appointments.length}`,
        },
      }))
    );
  };

  // Funzione per calcolare i giorni della settimana ISO
  const calculateWeekDays = (): string[] => {
    const startOfYear = dayjs(`${year}-01-01`).startOf("isoWeek");
    const startOfWeek = startOfYear.add(week - 1, "week");

    if (!startOfWeek.isValid()) {
      console.error("Data non valida:", startOfWeek.toString());
      return [];
    }

    //console.log("Anno:", year, "Mese:", month + 1, "Settimana:", week);
    //console.log("Inizio settimana calcolato:",startOfWeek.format("DD-MM-YYYY"));

    //console.log("date calcolate della settimana: ", Array.from({ length: 7 }, (_, i) =>startOfWeek.add(i, "day").format("DD-MM-YYYY")));

    return Array.from({ length: 7 }, (_, i) =>
      startOfWeek.add(i, "day").format("DD-MM-YYYY")
    );
  };

  //Funzione per calcolare le settimane di un mese
  const getWeeksOfMonth = (year: number, month: number) => {
    const startOfMonth = dayjs(`${year}-${month + 1}-01`); // Primo giorno del mese
    const endOfMonth = startOfMonth.endOf("month"); // Ultimo giorno del mese

    const weeks: { week: number; start: string; end: string }[] = [];
    let currentDate = startOfMonth.startOf("isoWeek"); // Lunedì della prima settimana ISO

    while (currentDate.isBefore(endOfMonth.endOf("isoWeek").add(1, "day"))) {
      const startOfWeek = currentDate;
      const endOfWeek = currentDate.add(6, "day");

      // Filtra settimane che intersecano effettivamente il mese selezionato
      if (endOfWeek.isBefore(startOfMonth) || startOfWeek.isAfter(endOfMonth)) {
        currentDate = currentDate.add(1, "week");
        continue; // Salta le settimane fuori dal mese
      }

      //formatto le date per anno, mese e giorno
      const startFormatted = startOfWeek.format("YYYY-MM-DD");
      const endFormatted = endOfWeek.format("YYYY-MM-DD");

      //Pusho le date in un array di oggetti contenenti le settimane del mese
      weeks.push({
        week: startOfWeek.isoWeek(),
        start: startFormatted,
        end: endFormatted,
      });

      currentDate = currentDate.add(1, "week");
    }

    return weeks;
  };

  //Funzione per cambiare la settimana quando ti trovi nella vista settimanale
  const goToSelectedWeek = () => {
    const selectedWeek = weeksInMonth.find((w) => w.week === week);

    if (selectedWeek && calendarRef.current) {
      const startDate = selectedWeek.start;
      setSelectedDate(startDate); // Aggiorna la data selezionata
      calendarRef.current.getApi().gotoDate(startDate);
    } else {
      console.warn("Settimana non valida per il mese selezionato.");
    }
  };

  //Quando cambiano l'anno o il mese, viene lanciata una funzione che recupera le settimane del mese selezionato
  useEffect(() => {
    const weeks = getWeeksOfMonth(year, month); //Funzione per recuperare le settimane in base al mese selezionato
    setWeeksInMonth(weeks);

    // Se cambio il mese e la settimana precedentemente selezionata non esiste, mostro la prima settimana del mese selezionato
    if (!weeks.find((w) => w.week === week) && weeks.length > 0) {
      setWeek(weeks[0].week); // Imposta la prima settimana
      goToSelectedWeek();
    }
  }, [year, month]);

  const days = calculateWeekDays();

  const debouncedHandleAppointmentByDate = debounce(
    handleAppointmentByDate,
    300
  ); // 300ms di debounce

  useEffect(() => {
    return () => {
      debouncedHandleAppointmentByDate.cancel(); // Cancella il debounce al dismount
    };
  }, []);

  const getYearRange = (currentYear: number, range: number) => {
    return Array.from({ length: range * 2 + 1 }, (_, i) =>
      dayjs()
        .year(currentYear - range + i)
        .year()
    );
  };

  //Se il calendario esiste e la vista è quella della settimana o del mese, aggiorno
  useEffect(() => {
    if (calendarRef.current) {
      if (selectedView === "dayGridWeek" || selectedView === "dayGridMonth") {
        const newDate = dayjs(`${year}-${month + 1}-01`).format("YYYY-MM-DD");
        calendarRef.current.getApi().gotoDate(newDate); // Aggiorna il calendario
        //console.log({ newDate });
      }
    }
  }, [year, month]);

  // Funzione per gestire il cambio di stato delle checkbox
  const handleAgendaFilterChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    agenda: string
  ) => {
    if (event.target.checked) {
      setSelectedAgendas((prev) => [...prev, agenda]);
    } else {
      setSelectedAgendas((prev) => prev.filter((item) => item !== agenda));
    }
  };

  useEffect(() => {
    setShowNoAppointmentsFound(false);
    if (
      selectedView === "dayGridMonth" ||
      selectedView === "dayGridWeek" ||
      selectedView === "resourceTimelineDay"
    ) {
      setValue("medico", "");
      setValue("specialita", "");
      setSelectedAgendas([]);
    }

    if (selectedView === "listDay" && agendaClicked) {
      setSelectedAgendas([agendaClicked]);
      setAgendaClicked(null);
    }
  }, [selectedView]);

  const handleMobileAppointments = async () => {
    if (isMobile) {
      const dataValues = getValues();

      console.log("Dati del form per mobile:", dataValues);

      if (!selectedDate) {
        console.warn("Data selezionata non disponibile.");
        return;
      }

      dataValues.dataIni = selectedDate;
      dataValues.dataFin = selectedDate;

      try {
        const response = await appointmentResearchNew(dataValues);

        console.log("Risposta API (mobile):", response);
        console.log("Dati restituiti (mobile):", response.data?.dati);

        const data = response.data?.dati;

        if (data) {
          const appointments = Object.keys(data)
            .filter(
              (key) =>
                key !== "listaMedici" &&
                key !== "listaSpecialita" &&
                key !== "parametriTabellone" &&
                key !== "agendeAperte" &&
                key !== "indisponibilita"
            )
            .reduce((acc, key) => {
              const appointment = data[key];
              if (appointment && Object.keys(appointment).length > 0) {
                acc.push(appointment);
              }
              return acc;
            }, [] as any[]);

          const flatAppointment = (
            Object.values(appointments) as AppointmentData[][]
          ).flatMap((element) => element.flat());

          console.log("Appuntamenti filtrati in mobile:", flatAppointment);

          const availableAppointments = flatAppointment.filter((key) => {
            return (
              key.STATOPRENOTAZIONE !== "Cancellata" &&
              key.STATOPRENOTAZIONE !== "Annullata"
            );
          });

          if (availableAppointments.length > 0) {
            setDataAppointments(availableAppointments);
          } else {
            console.warn(
              "Nessun appuntamento disponibile per la data selezionata."
            );
            setDataAppointments([]);
          }
        } else {
          console.warn("Nessun dato disponibile dall'API.");
          setDataAppointments([]);
        }
      } catch (error) {
        console.error("Errore durante la chiamata API (mobile):", error);
      }
    }
  };

  useEffect(() => {
    if (isMobile && selectedDate) {
      console.log("Eseguo la chiamata API specifica per mobile.");
      handleMobileAppointments();
    } else {
      console.log("Modalità desktop, non eseguo la chiamata mobile.");
    }
  }, [isMobile, selectedDate]);

  useEffect(() => {
    console.log("Appuntamenti disponibili:", dataAppointments);
  }, [dataAppointments]);

  const handleDateChange = (newDate: string) => {
    if (newDate && !isNaN(new Date(newDate).getTime())) {
      setSelectedDate(newDate);

      if (calendarRef.current) {
        calendarRef.current.getApi().gotoDate(newDate);
      }

      handleAppointmentByDate(selectedView);
    } else {
      console.error("Data non valida inserita:", newDate);
    }
  };

  const handleMobilePrevClick = () => {
    //Sottraggo un giorno alla data attuale, in modo da andare indietro di un giorno
    const previousDate = dayjs(selectedDate)
      .subtract(1, "day")
      .format("YYYY-MM-DD");
    setSelectedDate(previousDate);
    handleMobileAppointments(); // Aggiorna gli appuntamenti per la nuova data
  };

  const handleMobileNextClick = () => {
    //Aggiungo un giorno alla data attuale
    const nextDate = dayjs(selectedDate).add(1, "day").format("YYYY-MM-DD");
    setSelectedDate(nextDate);
    handleMobileAppointments();
  };

  //Funzione per scrollare il calendario fino all'ora attuale nella vista Scheduler
  const updateScrollTime = () => {
    const api = calendarRef.current?.getApi?.();
    if (!api) return;

    const now = dayjs().format("HH:mm:ss");

    requestAnimationFrame(() => {
      api.scrollToTime(now);
    });
  };

  // Parametri di default per gli orari del calendario
  const defaultSlotInterval = "00:15:00";
  const defaultMinTime = "07:00:00";
  const defaultMaxTime = "20:00:00";

  // Calcolo gli orari minimi e massimi in base ai parametri del tabellone
  // Se non sono definiti, uso i valori di default
  // Ci assicuriamo che i parametri siano dei numeri validi
  const computedSlotDuration =
    parametriTabellone?.INTERVALLO &&
    /^\d+$/.test(parametriTabellone.INTERVALLO)
      ? `00:${parametriTabellone.INTERVALLO.padStart(2, "0")}:00`
      : defaultSlotInterval;

  const computedMinTime = parametriTabellone?.ORAINI || defaultMinTime;
  const computedMaxTime = parametriTabellone?.ORAFIN || defaultMaxTime;

  const scrollTimeRef = useRef(dayjs().startOf("hour").format("HH:mm:ss"));

  // Se l'app è visualizzata su un dispositivo mobile (isMobile è true),
  // mostra una versione semplificata del calendario con componenti ottimizzati per piccoli schermi
  if (isMobile) {
    const filteredAppointments = dataAppointments.filter(
      (appointment) => appointment.DATAESAME === selectedDate
    );

    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
      >
        <Grid container spacing={2} width="100%">
          {/* Controlli di navigazione per la data */}
          <Grid
            item
            xs={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <ArrowBackIosNewIcon
              onClick={handleMobilePrevClick}
              sx={{ cursor: "pointer" }}
            />
            <Controller
              name="dataIni"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Data"
                  type="date"
                  inputProps={{ max: "9999-12-31" }}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  {...field}
                  value={selectedDate}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                    handleDateChange(e.target.value);
                  }}
                  sx={{ textAlign: "center", mx: 2 }}
                />
              )}
            />
            <ArrowForwardIosIcon
              onClick={handleMobileNextClick}
              sx={{ cursor: "pointer" }}
            />
          </Grid>

          {/* Appuntamenti */}
          {filteredAppointments.length > 0 ? (
            filteredAppointments.map((appointment, index) => (
              <Grid item xs={12} key={index}>
                <Box
                  onClick={() =>
                    handleOpenModal({
                      tipoAgenda: appointment.TIPOAGENDA,
                      nomeMedico: appointment.NOMEMEDICO, 
                      descEsame: appointment.DESCRESAME,
                      dataEsame: appointment.DATAESAME,
                      oraEsame: appointment.ORAESAME,
                      noteEsame: appointment.NOTEESAME,
                      nomePaziente: appointment.NOMEPAZIENTE,
                      cognomePaziente: appointment.COGNOMEPAZIENTE,
                      aziendaPrenotazione: appointment.AZIENDAPRENOTAZIONE,
                      codicePrenotazione: appointment.CODICEANAPRE, 
                      dataPrenotazione: appointment.DATAPRENOTAZIONE,
                    })
                  }
                  sx={{
                    boxShadow: 2,
                    borderRadius: "8px",
                    overflow: "hidden",
                    background: "#fff",
                    cursor: "pointer",
                  }}
                >
                  {/* Header con Tipo Agenda, Ora e Data */}
                  <Box
                    sx={{
                      backgroundColor: "#003267",
                      color: "#fff",
                      padding: "10px 16px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: "#003267",
                        padding: "4px 8px",
                        borderRadius: "16px",
                        border: "white solid",
                        fontSize: "12px",
                      }}
                    >
                      {appointment.TIPOAGENDA}
                    </Box>
                    <Typography fontSize={14} fontWeight="bold">
                      {formatHour(appointment.ORAESAME)} •{" "}
                      {dayjs(appointment.DATAESAME).format("DD/MM/YYYY")}
                    </Typography>
                  </Box>

                  {/* Corpo con descrizione esame */}
                  <Box sx={{ padding: "12px 16px" }}>
                    <Typography fontWeight="bold" sx={{ color: "#003267" }}>
                      {appointment.DESCRESAME}
                    </Typography>
                  </Box>

                  {/* Se sono presenti note, le mostro */}
                  {appointment.NOTEESAME && (
                    <Box
                      sx={{
                        backgroundColor: "#f5f5f5",
                        padding: "12px",
                        margin: "0 12px 12px",
                        borderRadius: "6px",
                      }}
                    >
                      <Typography
                        fontWeight="bold"
                        fontSize={12}
                        color="#003267"
                      >
                        Note:
                      </Typography>
                      <Typography fontSize={12}>
                        {appointment.NOTEESAME}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid>
            ))
          ) : (
            <Grid item xs={12} textAlign={"center"}>
              <Typography color="gray">Nessun appuntamento trovato</Typography>
            </Grid>
          )}
          {selectedAppointment && (
            <ModalAppointmentByAgenda
              open={openModal}
              onClose={handleCloseModal}
              appointmentData={selectedAppointment ?? {}}
            />
          )}
        </Grid>
      </Box>
    );
  }

  return (
    <>
      <Helmet>
        <title>Calendario appuntamenti</title>
      </Helmet>
      {!spostamentoMassivoView && (
        <Box display="flex" flexDirection="column" className="booking-calendar">
          <Box
            className="box-appointment"
            sx={{
              height:
                selectedView === "resourceTimelineDay"
                  ? { md: "180px", xs: "auto", sm: "auto" }
                  : { md: "180px", xs: "auto", sm: "auto" },
            }}
          >
            <Box
              className="box-title"
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                  height: "50px",
                }}
              >
                Calendario Prenotazioni
              </Typography>
              {selectedView === "resourceTimelineDay" && (
                <Button
                  variant="outlinedCustom"
                  size="small"
                  onClick={() => setSpostamentoMassivoView(true)}
                >
                  Spostamento Massivo
                </Button>
              )}
            </Box>
            <Grid container spacing={2}>
              {["timeGridDay", "listDay", "resourceTimelineDay"].includes(
                selectedView
              ) && (
                <Grid item xs={12} sm={12} md={3}>
                  <Controller
                    name="dataIni"
                    control={control}
                    render={({ field }) => (
                      <TextField
                        label="Data Inizio"
                        type="date"
                        inputProps={{ max: "9999-12-31" }}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        {...field}
                        value={field.value || ""}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                        onBlur={handleDateBlur} // Chiama la funzione di blur per validare e aggiornare
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleDateBlur(e as any); // Forza il tipo per compatibilità con handleDateBlur
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
              )}

              {selectedView === "dayGridMonth" && (
                <Grid container spacing={2} sx={{ margin: "0", padding: "0" }}>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="month-label">Mese</InputLabel>
                      <Select
                        labelId="month-label"
                        value={month}
                        onChange={(e) => {
                          const newMonth = Number(e.target.value);
                          setMonth(newMonth); // Aggiorna il mese

                          const weeksOfNewMonth = getWeeksOfMonth(
                            year,
                            newMonth
                          );

                          if (weeksOfNewMonth.length > 0) {
                            setWeek(weeksOfNewMonth[0].week); // Imposta la prima settimana del mese
                            setWeeksInMonth(weeksOfNewMonth); // Aggiorna le settimane disponibili
                          }
                        }}
                        label="Mese"
                      >
                        {Array.from({ length: 12 }, (_, i) => (
                          <MenuItem key={i} value={i}>
                            {dayjs().month(i).format("MMMM")}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Autocomplete
                      options={getYearRange(currentYear, 3)} // Anni disponibili
                      value={year}
                      onChange={(event, newValue) => {
                        const parsedYear = Number(newValue); // Converte l'input in numero
                        if (!isNaN(parsedYear) && parsedYear > 0) {
                          setYear(parsedYear); // Aggiorna lo stato
                          if (calendarRef.current) {
                            const newDate = dayjs(
                              `${parsedYear}-${month + 1}-01`
                            ).format("YYYY-MM-DD");
                            calendarRef.current.getApi().gotoDate(newDate); // Aggiorna la data nel calendario
                          }
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Anno"
                          type="number"
                          onBlur={(e) => {
                            const inputYear = Number(e.target.value); // Converte l'input in numero
                            if (!isNaN(inputYear) && inputYear > 0) {
                              setYear(inputYear); // Aggiorna lo stato
                              if (calendarRef.current) {
                                const newDate = dayjs(
                                  `${inputYear}-${month + 1}-01`
                                ).format("YYYY-MM-DD");
                                calendarRef.current.getApi().gotoDate(newDate); // Aggiorna la data nel calendario
                              }
                            }
                          }}
                          inputProps={{
                            ...params.inputProps,
                            min: 1900, // Anno minimo
                            max: 2100, // Anno massimo
                          }}
                        />
                      )}
                      getOptionLabel={(option) => option.toString()} // Visualizza l'opzione come stringa
                      disableClearable // Impedisce di svuotare il campo
                      freeSolo // Consente l'inserimento manuale dell'anno
                    />
                  </Grid>
                </Grid>
              )}

              {selectedView === "dayGridWeek" && (
                <Grid container spacing={2} sx={{ margin: "0", padding: "0" }}>
                  <Grid item xs={12} sm={12} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="week-label">Settimana</InputLabel>
                      <Select
                        labelId="week-label"
                        value={week}
                        onChange={(e) => {
                          setWeek(Number(e.target.value));
                          goToSelectedWeek(); // Aggiorna il calendario automaticamente
                        }}
                        label="Settimana"
                      >
                        {weeksInMonth.map(({ week, start, end }) => (
                          <MenuItem key={week} value={week}>
                            {`Settimana ${week}, dal ${dayjs(start).format(
                              "DD/MM"
                            )} al ${dayjs(end).format("DD/MM")}`}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl fullWidth>
                      <InputLabel id="month-label">Mese</InputLabel>
                      <Select
                        labelId="month-label"
                        value={month}
                        onChange={(e) => setMonth(Number(e.target.value))}
                        label="Mese"
                      >
                        {Array.from({ length: 12 }, (_, i) => (
                          <MenuItem key={i} value={i}>
                            {dayjs().month(i).format("MMMM")}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      options={getYearRange(currentYear, 3)} // Anni disponibili
                      value={year}
                      onChange={(event, newValue) => {
                        const parsedYear = Number(newValue); // Converte l'input in numero
                        if (!isNaN(parsedYear) && parsedYear > 0) {
                          setYear(parsedYear); // Aggiorna lo stato
                          if (calendarRef.current) {
                            const newDate = dayjs(
                              `${parsedYear}-${month + 1}-01`
                            ).format("YYYY-MM-DD");
                            calendarRef.current.getApi().gotoDate(newDate); // Aggiorna la data nel calendario
                          }
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Anno"
                          type="number"
                          onBlur={(e) => {
                            const inputYear = Number(e.target.value); // Converte l'input in numero
                            if (!isNaN(inputYear) && inputYear > 0) {
                              setYear(inputYear); // Aggiorna lo stato
                              if (calendarRef.current) {
                                const newDate = dayjs(
                                  `${inputYear}-${month + 1}-01`
                                ).format("YYYY-MM-DD");
                                calendarRef.current.getApi().gotoDate(newDate); // Aggiorna la data nel calendario
                              }
                            }
                          }}
                          inputProps={{
                            ...params.inputProps,
                            min: 1900, // Anno minimo
                            max: 2100, // Anno massimo
                          }}
                        />
                      )}
                      getOptionLabel={(option) => option.toString()} // Visualizza l'opzione come stringa
                      disableClearable // Impedisce di svuotare il campo
                      freeSolo // Consente l'inserimento manuale dell'anno
                    />
                  </Grid>
                </Grid>
              )}

              {selectedView !== "dayGridWeek" &&
                selectedView !== "dayGridMonth" && (
                  <Grid item xs={12} sm={12} md={3}>
                    <Controller
                      name="medico"
                      control={control}
                      render={({ field }) => {
                        const currentValues = Array.isArray(field.value)
                          ? field.value
                          : field.value
                          ? [field.value]
                          : [];

                        return (
                          <Autocomplete
                            limitTags={1}
                            multiple
                            disableCloseOnSelect
                            options={filteredDoctors.map((codMedico) => {
                              const doctor = dataAppointments.find(
                                (d) => d.CODMEDICO === codMedico
                              );
                              return {
                                label: doctor?.NOMEMEDICO || codMedico,
                                value: codMedico,
                              };
                            })}
                            getOptionLabel={(option) => option.label}
                            isOptionEqualToValue={(option, value) =>
                              option.value === value.value
                            }
                            value={currentValues.map((codMedico: string) => {
                              const doctor = dataAppointments.find(
                                (d) => d.CODMEDICO === codMedico
                              );
                              return {
                                label: doctor?.NOMEMEDICO || codMedico,
                                value: codMedico,
                              };
                            })}
                            onChange={(event, newValue) => {
                              const updated = newValue.map(
                                (option) => option.value
                              );
                              field.onChange(
                                updated.length === 1 ? updated[0] : updated
                              );
                            }}
                            renderInput={(params) => (
                              <TextField {...params} label="Medico" />
                            )}
                          />
                        );
                      }}
                    />
                  </Grid>
                )}

              {selectedView !== "dayGridWeek" &&
                selectedView !== "dayGridMonth" && (
                  <Grid item xs={12} sm={12} md={3}>
                    <Controller
                      name="specialita"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          select
                          label="Specialità"
                          fullWidth
                          value={field.value || ""}
                          onChange={(e) => field.onChange(e.target.value)}
                        >
                          <MenuItem value="">Selezionare Specialità</MenuItem>
                          {filteredSpecialties.map((specialty, index) => (
                            <MenuItem key={index} value={specialty}>
                              {specialty}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    />
                  </Grid>
                )}

              {selectedView !== "dayGridWeek" &&
                selectedView !== "dayGridMonth" && (
                  <Grid item xs={12} sm={12} md={3}>
                    <Controller
                      name="azienda"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          select
                          label="Azienda"
                          fullWidth
                          value={field.value || ""}
                          onChange={(e) => field.onChange(e.target.value)}
                        >
                          <MenuItem value="">Selezionare Azienda</MenuItem>
                          {structures.map((company, index) => (
                            <MenuItem key={index} value={company.id}>
                              {company.descrizione}
                            </MenuItem>
                          ))}
                        </TextField>
                      )}
                    />
                  </Grid>
                )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{
                gap: 2, // Spazio tra gli elementi
                marginTop: "16px", // Margine superiore
                flexWrap: "wrap", // Avvolgi gli elementi se necessario
              }}
            >
              {/* Componente pagina con le checkboxes per tipologia */}
              {agendaType.length > 0 &&
                agendaType // Filtra solo le agende con appuntamenti
                  .map((agenda, index) => (
                    <FormControlLabel
                      key={index}
                      control={
                        <Checkbox
                          checked={selectedAgendas.includes(agenda)} // Stato della checkbox
                          onChange={(e) => handleAgendaFilterChange(e, agenda)}
                          className={`agenda-${agenda
                            .toLowerCase()
                            .replace(/ /g, "-")
                            .replace(/\(.*\)/g, "")}`} // Rimuove tutto tra parentesi
                          sx={{
                            color: `agenda-${agenda}`,
                            "& .MuiSvgIcon-root": {
                              color: "inherit", // Eredita il colore definito
                            },
                          }}
                        />
                      }
                      label={
                        <Typography
                          sx={{
                            fontFamily: "Rubik, sans-serif",
                            color: "rgba(0, 0, 0, 0.7)",
                            textAlign: "center",
                          }}
                        >
                          {agenda}
                        </Typography>
                      }
                    />
                  ))}
              {showNoAppointmentsFound && (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Alert
                    severity="warning"
                    sx={{
                      justifyContent: "center",
                      border: "1px solid #e65100",
                      maxHeight: "35px",
                      alignContent: "center",
                      alignItems: "center",
                      "& .MuiAlert-icon": {
                        marginLeft: 2,
                        fontSize: 40,
                      },
                    }}
                  >
                    <Box>
                      <Typography
                        component="div"
                        marginTop={"20px"}
                        marginLeft={"20px"}
                        marginRight={"10px"}
                        marginBottom={"20px"}
                        fontSize={"20px"}
                        fontWeight={"bold"}
                      >
                        Nessun appuntamento disponibile per la data selezionata
                      </Typography>
                    </Box>
                  </Alert>
                </Box>
              )}
            </Grid>
          </Box>
          <Box
            sx={{
              overflow: "hidden",
              background: "white",
              ".fc-daygrid-day-frame": {},
              ".fc-daygrid-event": {},
              ".fc-scrollgrid": {
                borderRadius: 2,
              },
              height: "calc(100vh - 310px)",
            }}
          >
            <FullCalendar
              contentHeight="100%"
              height="100%"
              eventDidMount={(info) => {
                // solo per indisponibilità
                if (info.event.classNames?.includes("indisponibile")) {
                  // .fc-timeline-event-harness
                  const harness = info.el.parentElement as HTMLElement;

                  // z-index base basso
                  if (harness) harness.style.zIndex = "0";

                  // abilita hover
                  info.el.addEventListener("mouseenter", () => {
                    if (harness) harness.style.zIndex = "1000";
                  });
                  info.el.addEventListener("mouseleave", () => {
                    if (harness) harness.style.zIndex = "0";
                  });
                }
              }}
              moreLinkClick={(arg) => {
                // vai sulla vista lista del giorno cliccato
                arg.view.calendar.changeView("listDay", arg.date);

                // evita il popover standard
                return "none";
              }}
              allDaySlot={false}
              initialDate={dayjs().format("YYYY-MM-DD")}
              stickyHeaderDates={true}
              nowIndicator={true}
              // scrollTime="15:00:00"
              scrollTime={scrollTimeRef.current}
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                resourceTimelinePlugin,
                resourceTimeGridPlugin,
                listPlugin,
              ]}
              locale={itLocale}
              ref={calendarRef}
              schedulerLicenseKey="0733783808-fcs-1733393302"
              initialView="timeGridDay"
              resourceAreaHeaderContent="Medici operativi"
              resources={
                selectedView === "resourceTimelineDay"
                  ? (() => {
                      // Se medico è undefined, lo inizializzo come array vuoto
                      const medicoSelezionato = medico ?? [];
                      const tipoAgendaSelezionato =
                        selectedAgendas.length > 0 ? selectedAgendas : [];
                      const mediciDaAppuntamenti = dataAppointments
                        .filter(
                          (appointment) =>
                            appointment.DATAESAME === selectedDate &&
                            (medicoSelezionato.length === 0 ||
                              medicoSelezionato.includes(
                                appointment.CODMEDICO
                              )) &&
                            (tipoAgendaSelezionato.length === 0 ||
                              tipoAgendaSelezionato.includes(
                                appointment.TIPOAGENDA
                              ))
                        )
                        .map((appointment) => appointment.NOMEMEDICO);

                      // Prendo anche i nomi dei medici dalle indisponibilità
                      const mediciDaIndisponibilita = indisponibilita.map(
                        (item) => item.NOMEMEDICO
                      );

                      // Prendo anche i nomi dei medici dalle disponibilità
                      const mediciDaDisponibilita = disponibilita.map(
                        (item) => item.NOMEMEDICO
                      );
                      // Combino e rimuovo i duplicati
                      const mediciUnici = Array.from(
                        new Set([
                          ...mediciDaAppuntamenti,
                          ...mediciDaIndisponibilita,
                          ...mediciDaDisponibilita,
                        ])
                      );

                      // Se non ci sono medici disponibili, mostra un messaggio
                      if (mediciUnici.length === 0) {
                        return [
                          {
                            id: "nessun-medico-disponibile",
                            title: "Nessun medico disponibile",
                          },
                        ];
                      }

                      // Restituisco solo i medici con appuntamenti e indisponibilità che rispettano i filtri
                      return mediciUnici.map((nomeMedico) => ({
                        id: nomeMedico,
                        title: nomeMedico,
                      }));
                    })()
                  : []
              }
              eventClick={(info) => {
                const currentView = calendarRef.current.getApi().view.type;

                if (info.event.id?.startsWith("indisponibilita-")) {
                  return;
                }
                if (
                  currentView === "dayGridMonth" ||
                  currentView === "dayGridWeek"
                ) {
                  // Estrae il tipo di agenda dall'evento cliccato (es. "Privati\n5 appuntamenti")
                  const agendaType = info.event.title.split("\n")[0];

                  // Se non è già selezionata, aggiunge l'agenda ai filtri attivi
                  setSelectedAgendas((prev) =>
                    prev.includes(agendaType) ? prev : [...prev, agendaType]
                  );

                  setAgendaClicked(agendaType); // Salva temporaneamente l’agenda cliccata
                  // Passa alla vista listDay e mostra gli appuntamenti di quella agenda
                  calendarRef.current
                    .getApi()
                    .changeView("listDay", info.event.startStr);
                } else {
                  console.log(
                    "info molto divertenti",
                    info.event.extendedProps
                  );

                  const appointmentData = {
                    tipoAgenda: info.event.extendedProps.tipoAgenda,
                    nomeMedico: info.event.extendedProps.medico,
                    descEsame: info.event.extendedProps.description,
                    dataEsame: info.event.startStr,
                    oraEsame: info.event.extendedProps.oraEsame,
                    durataEsame: info.event.extendedProps.durataEsame,
                    codicePrenotazione:
                      info.event.extendedProps.codicePrenotazione,
                    dataPrenotazione: info.event.extendedProps.dataPrenotazione,
                    noteEsame: info.event.extendedProps.noteEsame,
                    nomePaziente: info.event.extendedProps.nomePaziente,
                    cognomePaziente: info.event.extendedProps.cognomePaziente,
                    aziendaPrenotazione:
                      info.event.extendedProps.aziendaPrenotazione,
                  };
                  console.log({ appointmentData });

                  handleOpenModal(appointmentData);
                }
              }}
              events={handleEvents()}
              eventContent={renderEventContent}
              selectable={true}
              editable={true}
              slotEventOverlap={false}
              eventOverlap={false}
              eventMinHeight={30}
              slotDuration={computedSlotDuration}
              slotMinTime={computedMinTime}
              slotMaxTime={computedMaxTime}
              slotLabelInterval="00:10"
              slotLabelFormat={{
                hour: "numeric",
                minute: "2-digit",
                omitZeroMinute: false,
              }}
              // slotMinTime={parametriTabellone?.ORAINI ?? "08:00:00"}
              // slotMaxTime={parametriTabellone?.ORAFIN ?? "20:00:00"}
              eventMaxStack={4}
              dayMaxEvents={false}
              datesSet={(info) => {
                if (calendarRef.current && calendarRef.current.calendar) {
                  const currentDate =
                    calendarRef.current.calendar.currentData.currentDate;
                  const formattedDate = format(currentDate, "yyyy-MM-dd");
                  //console.log({ formattedDate });

                  // Verifica se la data selezionata è già quella corrente
                  console.log({ formattedDate });
                  console.log({ selectedDate });

                  if (formattedDate !== selectedDate) {
                    setSelectedDate(formattedDate);
                    setValue("dataIni", formattedDate);
                  }

                  // Verifica se la vista corrente è diversa
                  if (info.view.type !== selectedView) {
                    setSelectedView(info.view.type);
                  }

                  // Chiamata API solo se c'è un reale cambiamento
                  if (
                    formattedDate !== selectedDate || // Cambiata la data
                    info.view.type !== selectedView // Cambiata la vista
                  ) {
                    debouncedHandleAppointmentByDate(info.view.type);
                  }
                }
              }}
              headerToolbar={{
                start: "prev,title,next",
                center: "",
                right:
                  "today,dayGridMonth,dayGridWeek,timeGridDay,listDay,resourceTimelineDay",
              }}
              titleFormat={{
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              }}
              views={{
                resourceTimelineDay: {
                  title: "Scheduler",
                  buttonText: "Scheduler",
                  slotMinWidth: 85,
                  slotDuration: "00:05:00", // 5 minuti per la vista giornaliera
                  slotLabelInterval: "00:10:00", // Etichette ogni 10 minuti
                  slotLabelFormat: {
                    hour: "2-digit",
                    minute: "2-digit",
                    omitZeroMinute: false,
                  },
                },
                listDay: {
                  title: "Lista",
                  buttonText: "Lista",
                },
                timeGridDay: {
                  // slotDuration: "00:10:00", // <-- aggiungi o sovrascrivi qui
                  // slotLabelInterval: "00:10:00",
                  //Formattazione per mostrare giorno e data nel calendario
                  slotLabelFormat: {
                    hour: "2-digit",
                    minute: "2-digit",
                    omitZeroMinute: false,
                  },
                  // slotMinTime:"07:00:00",
                  // slotMaxTime:"22:10:00"
                },
              }}
              customButtons={{
                prev: {
                  click: () => {
                    handlePrevClick();
                    setShowNoAppointmentsFound(false);
                  },
                },
                next: {
                  click: () => {
                    handleNextClick();
                    setShowNoAppointmentsFound(false);
                  },
                },
                today: {
                  click: () => {
                    handleTodayClick();
                    setShowNoAppointmentsFound(false);
                  },
                  text: "Oggi",
                },
              }}
            />

            {selectedAppointment && (
              <ModalAppointmentByAgenda
                open={openModal}
                onClose={handleCloseModal}
                appointmentData={selectedAppointment ? selectedAppointment : {}}
              />
            )}
          </Box>
        </Box>
      )}
      {spostamentoMassivoView && (
        <SpostamentoMassivo
          setSpostamentoMassivoView={setSpostamentoMassivoView}
        />
      )}
    </>
  );
};

export default BookingCalendar;
